import React, { DragEvent, useState } from 'react';

export type DropZoneProps = {
  children: React.JSX.Element[] | React.JSX.Element;
  onDropFiles: (files: File[]) => void;
  disabled?: boolean;
  dragOverStyle?: Record<string, string>;
};

export const DropZone = ({
  children,
  onDropFiles,
  disabled = false,
  dragOverStyle = {},
  ...passDownProps
}: DropZoneProps): React.JSX.Element => {
  // We use a counter to ignore drag leave events when hovering child elements
  const [dragCounter, setDragCounter] = useState(0);
  const isDragging = dragCounter > 0;

  const dropHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const selectedFiles = Array.from(e.dataTransfer.files);
    onDropFiles(selectedFiles);
    setDragCounter(0);
  };

  const dragOverHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const dragEnterHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter + 1);
  };

  const dragLeaveHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter - 1);
  };

  if (disabled) {
    return <div {...passDownProps}>{children}</div>;
  }

  const style = isDragging ? dragOverStyle : {};

  return (
    <div
      {...passDownProps}
      style={style}
      onDragEnter={dragEnterHandler}
      onDragLeave={dragLeaveHandler}
      onDragOver={dragOverHandler}
      onDrop={dropHandler}
    >
      {children}
    </div>
  );
};
